<template>
  <base-dialog
    :action="onAction"
    :action-name="'Delete'"
    :close="onClose"
    :title="'Delete Product'"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <div>
        <p>
          If you delete this product, you won't be able to create new subscriptions to it.
          Existing subscriptions won't be affected and will continue to be billed as usual until canceled.<br>
          <br>
          <b>Are you sure you want to delete this product? This can't be undone.</b>
        </p>
      </div>
    </template>
  </base-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import BaseDialog from "../Common/BaseDialog"

export default {
  components: { BaseDialog },
  props: {
    id: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      name: ''
    }
  },
  methods:{
    ...mapActions(['deleteService']),
    onClose(){
      this.$emit('close')
    },
    async onAction() {
      const payload = {
        id: this.id,
      }

      await this.deleteService(payload)

      this.$emit('action', payload)
    }
  }
}
</script>
